import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {vars} from '../common'

const Badge = ({ badge }) =>
  badge > 0 &&
<BadgeContainer>{badge}</BadgeContainer>

Badge.propTypes = {
  badge: PropTypes.number
}

export default Badge


const BadgeContainer = styled.span`
  position: fixed;
  top: -10px;
  right: -5px;
  background-color: ${vars.red};
  color: white;
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  border-radius: 50%;
`


// WEBPACK FOOTER //
// ./src/ChatWidget/components/Launcher/Badge.js